import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";
import HomePage from "@/components/HomePage";
import MechanicalSprings from "@/components/MechanicalSprings";
import MechanicalSpringsCompression from "@/components/MechanicalSpringsCompression";
import MechanicalSpringsExtension from "@/components/MechanicalSpringsExtension";
import MechanicalSpringsTorsion from "@/components/MechanicalSpringsTorsion";
import HarrowTine from "@/components/HarrowTine";
import HarrowTineSprings from "@/components/HarrowTineSprings";
import GarageDoorSprings from "@/components/GarageDoorSprings";
import GarageDoorSpringsTorsion from "@/components/GarageDoorSpringsTorsion";
import GarageDoorSpringsExtension from "@/components/GarageDoorSpringsExtension";
import AboutUs from '@/components/AboutUs';
import AboutUsPage from '@/components/AboutUsPage';

Vue.use(Router);

export default new Router({
  linkActiveClass: "active",
  mode: 'history',
  routes: [
    {
      path: "/hellowworld",
      name: "HelloWorld",
      component: HelloWorld
    },
    {
      path: "/",
      name: "HomePage",
      component: HomePage
    },
    {
      path: "/mechanical-springs",
      name: "MechanicalSprings",
      component: MechanicalSprings,
      children: [
        {
          path: "",
          redirect: "compression"
        },
        {
          path: "compression",
          name: "Compression",
          component: MechanicalSpringsCompression
        },
        {
          path: "extension",
          name: "Extension",
          component: MechanicalSpringsExtension
        },
        {
          path: "torsion",
          name: "Torsion",
          component: MechanicalSpringsTorsion
        }
      ]
    },
    {
      path: "/harrow-tine",
      component: HarrowTine,
      children: [
        {
          path: "",
          name: "HarrowTineSprings",
          component: HarrowTineSprings
        }
      ]
    },
    {
      path: "/garage-door-springs",
      component: GarageDoorSprings,
      children: [
        {
          path: "",
          redirect: "torsion"
        },
        {
          path: "torsion",
          name: "GarageDoorSpringsTorsion",
          component: GarageDoorSpringsTorsion
        },
        {
          path: "extension",
          name: "GarageDoorSpringsExtension",
          component: GarageDoorSpringsExtension
        }
      ]
    },
    {
      path: "/about-us",
      component: AboutUs,
      children: [
        {
          path: "",
          name: "AboutUsPage",
          component: AboutUsPage
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js